import React, { useState, useEffect } from "react";

import { Image, Transformation } from "cloudinary-react";

import "./photo-upload.styles.scss";
import {
  fetchPhoto,
  openUploadWidget,
} from "../../utils/cloudinary/cloudinary-service";
import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles({
  container: {
    position: "relative",
    margin: "20px",
    width: "300px",
    height: "300px",
    backgroundColor: "gray",
    borderRadius: "10px",
    cursor: "pointer",
    "&:hover": {
      "& $image": { opacity: 0.4 },
      "& $button": {
        opacity: 1,
      },
    },
  },
  image: {
    opacity: "1",
    display: "table-cell",
    width: "100%",
    height: "auto",
    transition: ".5s ease",
    backfaceVisibility: "hidden",
    verticalAlign: "middle",
  },
  button: {
    transition: ".5s ease",
    opacity: (props) => (props.imgExists ? 0 : 1),
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    msTransform: "translate(-50%, -50%)",
    textAlign: "center",
  },
  text: {
    backgroundColor: "black",
    color: "white",
    fontSize: "16px",
    padding: "16px 32px",
  },
});

const PhotoUploader = ({ handleChange, name, value, ...props }) => {
  const [image, setImage] = useState(value);
  const classes = useStyles({ imgExists: image ? true : false });
  const beginUpload = (event) => {
    const uploadOptions = {
      uploadPreset: "upload",
      sources: ["local", "url", "camera"],
    };

    openUploadWidget(uploadOptions, (error, photos) => {
      if (!error) {
        if (photos.event === "success") {
          setImage(photos.info.public_id);
          handleChange({
            target: { value: photos.info.public_id, name: name },
          });
        }
      } else {
        //TODO: Errorhandling
        console.log(error);
      }
    });
  };
  useEffect(() => {
    fetchPhoto("image", setImage);
  }, []);
  return (
    <div className={classes.container} onClick={() => beginUpload()}>
      <section>
        {image ? (
          <Image
            key={image}
            publicId={image + ".png"}
            className={classes.image}
          >
            <Transformation
              quality="auto"
              radius="10"
              width="300"
              crop="scale"
            />
          </Image>
        ) : null}

        <div className={classes.button}>
          <div className={classes.text}>
            {!image ? "Bild Hochladen" : "Bild ändern"}
          </div>
        </div>
      </section>
    </div>
  );
};

export default PhotoUploader;
